module.exports = __webpack_public_path__ + "media/honey-icons/icon-email-41b133ff.svg";